import { render, staticRenderFns } from "./projectRouteCard.vue?vue&type=template&id=637fc7b0"
import script from "./projectRouteCard.vue?vue&type=script&lang=js"
export * from "./projectRouteCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports